"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobileDetection_1 = require("../utils/mobileDetection");
function useNow(intervalMs) {
    var _a = (0, react_1.useState)(Date.now()), now = _a[0], setNow = _a[1];
    (0, react_1.useEffect)(function () {
        var id = setInterval(function () { return setNow(Date.now()); }, intervalMs);
        return function () { return clearInterval(id); };
    }, [intervalMs]);
    return now;
}
function timeLabelFrom(tsMs, now) {
    var ts = Number.isFinite(tsMs) ? tsMs : now;
    var diffMin = Math.max(0, Math.floor((now - ts) / 60000));
    if (diffMin < 1)
        return "Just now";
    if (diffMin === 1)
        return "1 min ago";
    return "".concat(diffMin, " mins ago");
}
var ChatView = function (_a) {
    var title = _a.title, messages = _a.messages, inputValue = _a.inputValue, onChangeInput = _a.onChangeInput, onSend = _a.onSend, onEmoji = _a.onEmoji, onAttach = _a.onAttach;
    var scrollRef = (0, react_1.useRef)(null);
    var taRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(false), isComposing = _b[0], setIsComposing = _b[1];
    var now = useNow(60000);
    var isMobile = (0, mobileDetection_1.useIsMobile)();
    // autoscroll to bottom when messages change
    (0, react_1.useEffect)(function () {
        var el = scrollRef.current;
        if (!el)
            return;
        el.scrollTop = el.scrollHeight;
    }, [messages]);
    // autosize textarea up to 2 lines
    (0, react_1.useEffect)(function () {
        var ta = taRef.current;
        if (!ta)
            return;
        // reset height to measure
        ta.style.height = "auto";
        var cs = window.getComputedStyle(ta);
        var lineHeight = parseFloat(cs.lineHeight || "20") || 20;
        var paddingTop = parseFloat(cs.paddingTop || "0") || 0;
        var paddingBottom = parseFloat(cs.paddingBottom || "0") || 0;
        var borderTop = parseFloat(cs.borderTopWidth || "0") || 0;
        var borderBottom = parseFloat(cs.borderBottomWidth || "0") || 0;
        var maxHeight = lineHeight * 2 + paddingTop + paddingBottom + borderTop + borderBottom;
        var desired = Math.min(ta.scrollHeight, maxHeight);
        ta.style.height = "".concat(desired, "px");
        ta.style.overflowY = ta.scrollHeight > maxHeight ? "auto" : "hidden";
    }, [inputValue]);
    var handleKeyDown = function (e) {
        if (e.key === "Enter" && !e.shiftKey && !isComposing) {
            e.preventDefault();
            onSend();
        }
    };
    var sendDisabled = !inputValue.trim();
    return (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", height: "100%" } },
        react_1.default.createElement("div", { ref: scrollRef, style: {
                padding: isMobile ? 12 : 16,
                paddingTop: isMobile ? 8 : 10,
                height: isMobile ? 300 : 380,
                overflowY: "auto",
                background: "#ffffff",
            } }, messages.map(function (m) {
            var _a;
            var isUser = m.role === "user";
            var computedLabel = (_a = m.timeLabel) !== null && _a !== void 0 ? _a : (m.createdAt ? timeLabelFrom(m.createdAt, now) : undefined);
            return (react_1.default.createElement("div", { key: m.id, style: {
                    display: "flex",
                    alignItems: "flex-end",
                    gap: 8,
                    marginBottom: 12,
                    justifyContent: isUser ? "flex-end" : "flex-start",
                } },
                !isUser && (react_1.default.createElement("img", { src: "assets/Fermaglo_Image01.png", alt: "", width: 24, height: 24, style: {
                        alignSelf: "flex-start",
                        borderRadius: 6,
                        objectFit: "contain",
                    } })),
                react_1.default.createElement("div", { style: {
                        maxWidth: isMobile ? "85%" : "78%",
                        background: "#F3F4F6",
                        color: isUser ? "#0B6623" : "#0000FF",
                        borderRadius: 8,
                        padding: isMobile ? "8px 10px" : "10px 12px",
                        boxShadow: "0 1px 0 rgba(0,0,0,0.03)",
                    } },
                    react_1.default.createElement("div", { style: { whiteSpace: "pre-wrap" } }, m.text.replace(/support@fermaglo\.com/g, "bp@fermaglo.com")),
                    computedLabel && (react_1.default.createElement("div", { style: {
                            fontSize: 11,
                            color: "#6B7280",
                            marginTop: 6,
                        } }, computedLabel))),
                isUser && (react_1.default.createElement("div", { style: {
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        background: "#E5E7EB",
                        display: "grid",
                        placeItems: "center",
                        color: "#6B7280",
                        fontSize: 14,
                    } },
                    react_1.default.createElement("span", { style: { lineHeight: 1 } }, "\uD83D\uDC64")))));
        })),
        react_1.default.createElement("div", { style: {
                padding: isMobile ? 10 : 12,
                paddingTop: isMobile ? 8 : 10,
                borderTop: "1px solid #F0F2F5",
                background: "#fff",
            } },
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    alignItems: "flex-end",
                    gap: 8,
                    border: "1px solid #E5E7EB",
                    borderRadius: 999,
                    padding: "6px 10px",
                    background: "#fff",
                } },
                react_1.default.createElement("textarea", { ref: taRef, value: inputValue, onChange: function (e) { return onChangeInput(e.target.value); }, onKeyDown: handleKeyDown, onCompositionStart: function () { return setIsComposing(true); }, onCompositionEnd: function () { return setIsComposing(false); }, placeholder: "Type Your Question...", rows: 1, style: {
                        flex: 1,
                        resize: "none",
                        border: "none",
                        outline: "none",
                        fontSize: isMobile ? 13 : 14,
                        color: "#111827",
                        padding: "6px 6px",
                        lineHeight: "20px",
                        background: "transparent",
                        maxHeight: 64, // ~2 lines con padding/border
                    }, "aria-label": "Message input" }),
                react_1.default.createElement("button", { onClick: onSend, disabled: sendDisabled, style: {
                        display: "grid",
                        placeItems: "center",
                        width: isMobile ? 30 : 34,
                        height: isMobile ? 30 : 34,
                        borderRadius: "50%",
                        background: sendDisabled ? "#9CA3AF" : "#5B21B6",
                        color: "#fff",
                        border: "1px solid #4C1D95",
                        cursor: sendDisabled ? "not-allowed" : "pointer",
                        fontSize: isMobile ? 14 : 16,
                        transition: "opacity .15s",
                        opacity: sendDisabled ? 0.7 : 1,
                    }, "aria-label": "Send", type: "button" }, "\u27A4")))));
};
exports.default = ChatView;
